import { render, staticRenderFns } from "./custom-banner.vue?vue&type=template&id=03a11620&scoped=true&"
import script from "./custom-banner.vue?vue&type=script&lang=js&"
export * from "./custom-banner.vue?vue&type=script&lang=js&"
import style0 from "./custom-banner.vue?vue&type=style&index=0&id=03a11620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a11620",
  null
  
)

export default component.exports